/* eslint-disable */
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ActionCreators from "../../actions";
import { setLyftReportData, setTuroReportData, setOtherReportData } from "../../utils/functions";
import { getCertificateFontDownloads } from "../../utils/certificateFontDownloads";
import "./certificateDownloadButton.css";

import React from "react";
import moment from "moment";
import {
  PDFDownloadLink,
  Page,
  Text,
  View,
  Image,
  Document,
  StyleSheet,
  Font
} from "@react-pdf/renderer";
// import { imageBaseUrl } from "../utils/api";
import LyftImg from "../../Assets/lyftimg.png";
import TicketImg from "../../Assets/tickimg.png";
import kalamFont from '../../font/Kalam-Light.ttf';
import '../../font/registerPatrickHandAndCaveatPdf';
import tickimg from '../../Assets/tickimgOld.png';
import Arial from '../../font/ARIAL.TTF';
import Arialbold from '../../font/ARIALBD 1.TTF'
import Inter from '../../font/Inter-VariableFont.ttf';
import Lato from '../../font/Lato-Regular.ttf';
import InspectorPoint from "../../Assets/Inspector Point.png";

Font.register({ family: 'kalamFont', format: "truetype", src: kalamFont });
Font.register({family: 'Arial', format: "truetype", src: Arial});
Font.register({family: 'Arialbold', format: "truetype", src: Arialbold});
Font.register({family: 'Inter', format: "truetype", src: Inter});
Font.register({family: 'Lato', format: "truetype", src: Lato});

const styles = StyleSheet.create({
  body: {
    paddingBottom: 65,
    paddingHorizontal: 15,
  },
  head: {
    width: '40%'
  },
  headimg: {
    width: '72%',
    marginTop: '35px',
    marginLeft: 20,
  },
  heading: {
    width: '60%',

  },
  headText: {
    marginTop: '35px',
    textAlign: 'center',
    fontWeight: 'bold',
    fontSize: '23px',
    letterSpacing: 1,
    fontFamily:'Arialbold'

  },
  headparagraph: {
    marginTop: '10px',
    textAlign: 'center',
    fontWeight: '700',
    fontFamily: 'Arialbold',
    fontSize: '13px',
    letterSpacing: 1,
    paddingHorizontal: 26,
  },
  bodycontent:{
    display: 'flex',
    flexDirection: 'row'
  },
  mainContent: {
    width: '50%',
    marginLeft:10,

  },
  Submithead: {
    marginTop: '24px',
    marginLeft: '10px',
    fontFamily: 'Arialbold',
    fontSize: '16px',
    fontWeight: 'bold',
  },
  submitpara: {
    fontWeight: '200',
    marginTop: '8px',
    marginLeft: '10px',
    fontFamily: 'Inter',
    fontSize: '16px'
  },
  TopName: {
    marginTop: '10px',
    marginLeft: '10px',
    fontFamily: 'Inter',
    fontSize: '15px',
    fontWeight: 500,
    flexShrink: 0,

  },
  line: {
    borderBottomWidth: 1,
    borderBottomColor: "#000000",
    marginLeft: 3,
    marginTop: '13px',
    flex: 1,
    marginRight: 6,
    justifyContent: 'flex-end',
  },
  carvinline: {
    borderBottomWidth: 1,
    borderBottomColor: "#000000",
    marginLeft: 3,
    marginTop: '13px',
    flex: 1,
    marginRight: 6,
    justifyContent: 'flex-end',
  },
  Licenseline: {
    borderBottomWidth: 1,
    borderBottomColor: "#000000",
    marginLeft: 3,
    marginTop: '13px',
    flex: 1,
    marginRight: 6,
    justifyContent: 'flex-end',
  },
  Yearline: {
    borderBottomWidth: 1,
    borderBottomColor: "#000000",
    marginLeft: 3,
    marginTop: '13px',
    flex: 1,
    marginRight: 6,
    justifyContent: 'flex-end',
  },
  Registrationline: {
    borderBottomWidth: 1,
    borderBottomColor: "#000000",
    marginLeft: 5,
    marginTop: '13px',
    flex: 1,
    marginRight: 6,
    justifyContent: 'flex-end',
  },
  CoNameline: {
    borderBottomWidth: 1,
    borderBottomColor: "#000000",
    marginLeft: 3,
    marginTop: '13px',
    flex: 1,
    marginRight: 6,
    justifyContent: 'flex-end',
  },
  CoAddressline: {
    borderBottomWidth: 1,
    borderBottomColor: "#000000",
    marginLeft: 3,
    marginTop: '13px',
    flex: 1,
    marginRight: 6,
    justifyContent: 'flex-end',
  },
  Mechanicline: {
    borderBottomWidth: 1,
    borderBottomColor: "#000000",
    marginLeft: 3,
    marginTop: '13px',
    flex: 1,
    marginRight: 6,
    justifyContent: 'flex-end',
  },
  Getaroundline: {
    borderBottomWidth: 1,
    borderBottomColor: "#000000",
    marginLeft: 3,
    marginTop: '13px',
    flex: 1,
    marginRight: 6,
    justifyContent: 'flex-end',
  },
  Dateline: {
    borderBottomWidth: 1,
    borderBottomColor: "#000000",
    marginLeft: 3,
    marginTop: '13px',
    flex: 1,
    marginRight: 6,
    justifyContent: 'flex-end',
  },
  Signatureline: {
    borderBottomWidth: 1,
    borderBottomColor: "#000000",
    marginLeft: 3,
    marginTop: '-80px',
    flex: 1,
    marginRight: 6,
  },
  backimg: {
    width: '90%',
    marginTop: '10px',
    marginLeft: 30,
    height: '400px'
  },
  checkbox: {
    border: "1 px solid #000000",
    width: '14.97px',
    height: '14px',
    left: '49px',
    top: '15px',
    position:'relative'
  },
  checkbox1: {
    border: "1 px solid #000000",
    width: '14.97px',
    height: '14px',
    left: '75px',
    top: '15px',

  },
  RegText1: {
    top: '15px',
    left: '83px',
    fontSize: '14px'

  },
  RegText: {
    top: '15px',
    left: '57px',
    fontSize: '14px'

  },
  RightContent: {
    width: '50%',
    // height: '80%'
  },
  righthead: {
    marginTop: '24px',
    fontWeight: 'bold',
    fontFamily: 'Arial',
    left: '14px'
  },
  passTtext: {
    width: '15%',
    marginTop:'24px',
    fontWeight: 'bold',
    fontFamily: 'Arialbold',
    textAlign:'center',
    fontSize:'14px'

  },
  borderbox: {
    border: '1px solid #000000',
    padding: '30px'
  },
  Rightcheckbox:{
    border: "1 px solid #000000",
    width: '15.97px',
    height: '15px',
    display:'block',
    marginLeft:'auto',
    marginRight:'auto',
    marginTop:'auto',
    marginBottom:'auto',
    position:'relative'
  },
  content:
    {
      marginLeft: '7%', fontWeight: '500', fontFamily: 'Inter', fontSize: '14px',

      border: '1px solid #000000',
      padding: '8px',
      width: '280px',
      borderTopColor: '#ffffff',

    },
  headcontent:
    {
      marginLeft: '7%', fontWeight: '700', fontFamily: 'Arial', fontSize: '15px',
      top: '6px',
      border: '1px solid #000000',
      padding: '8px',
      width: '280px',
      borderTopColor: '#ffffff',

    },
  rightsideborder:{
    width: '15%',
    border:'1px solid black',
    borderTopWidth: 0,
    borderLeftWidth:0
  },
  formdata:{
    marginTop:'-7',
    fontFamily:'Lato',
    fontSize:'16px',
    marginLeft:'10px',
    marginBottom:-5,
  },
  Topborder:{
    width: '70%',
    marginLeft: 10,
    border:'1px solid black',
    borderTopWidth: 0
  },
  InspectionTxt:
    {
      width: '70%',
      marginRight: 10,
      marginTop:'24px',
      marginLeft:14,
      fontSize:'14px',
      fontWeight:'bold',
      fontFamily:'Arialbold'
    },
});

function GetAroundCertificateDownLoad({
  certificateData,
  vehicleChecksArray,
  handwritingFont = "kalamFont",
  fileName = "Vehicle-certificate.pdf",
  linkLabel = "Download pdf",
}) {
  const handwritingStyle = { fontFamily: handwritingFont };

  return (
    <div className="App">
      <PDFDownloadLink
        wrap={false}
        document={
          <Document>
            {/* Auto-height page (A3 width, min A3 height) so the certificate always fits on a single page */}
            <Page size={{ width: 841.89 }} style={[styles.body, { minHeight: 1190.55 }]} wrap={false}>
              <View style={styles.bodycontent}>
                <View style={styles.head}>
                  <Image style={styles.headimg}
                         src={'https://res.cloudinary.com/dgjordf6e/image/upload/v1677489133/Getaround_Logo_1_ms5nbk.png'}/>
                </View>
                <View style={styles.heading}>
                  <Text style={styles.headText}>Getaround Vehicle Inspection Form</Text>
                  <Text style={styles.headparagraph}>To qualify, your vehicle must pass all inspection points. This{"\n"}inspection form must be completed by a certified mechanic.</Text>

                </View>
              </View>
              <View style={[styles.bodycontent, { marginTop: 30 }]}>
                <View style={styles.mainContent}>
                  <Text style={styles.Submithead}>
                    Submit your inspection to Getaround
                  </Text>
                  <Text style={[styles.submitpara, { marginTop: 3 }]}>
                    Once the vehicle has passed inspection, the host must email this inspection form to their Getaround Account Executive.
                  </Text>
                  <View style={{display: 'flex', flexDirection: 'row', alignItems: 'flex-end'}}>
                    <Text style={styles.TopName}>Host Name</Text>
                    <View style={styles.line}>
                      <Text style={[styles.formdata, handwritingStyle]}>
                       {`${certificateData?.CertificateData?.Host_Name || ''} ${certificateData?.CertificateData?.Host_Last_Name || ''}`.trim()}</Text>
                    </View>
                  </View>
                  <View style={{display: 'flex', flexDirection: 'row', alignItems: 'flex-end'}}>
                    <Text style={styles.TopName}>Host Email</Text>
                    <View style={styles.line}>
                      <Text style={[styles.formdata, handwritingStyle]}>
                        {certificateData && certificateData?.CertificateData?.Host_Email}
                      </Text>
                    </View>
                  </View>
                  <View style={{display: 'flex', flexDirection: 'row', alignItems: 'flex-end'}}>
                    <Text style={styles.TopName}>Car VIN</Text>
                    <View style={styles.carvinline}>
                      <Text style={[styles.formdata, handwritingStyle]}>
                        {certificateData&& certificateData?.CertificateData?.Vin} </Text>
                    </View>
                  </View>
                  <View style={{display: 'flex', flexDirection: 'row', alignItems: 'flex-end'}}>
                    <Text style={styles.TopName}>Car Mileage</Text>
                    <View style={styles.line}>
                      <Text style={[styles.formdata, handwritingStyle]}>
                        {certificateData&& certificateData?.CertificateData?.Mileage}
                      </Text>
                    </View>
                  </View>
                  <View style={{display: 'flex', flexDirection: 'row', alignItems: 'flex-end'}}>
                    <Text style={styles.TopName}>License Plate</Text>
                    <View style={styles.Licenseline}>
                      <Text style={{marginTop:'-7',fontFamily:'Lato',fontSize:'14px',marginLeft:'5px',marginBottom:0}}>
                        {certificateData && certificateData?.CertificateData?.licensePlateNumber}
                      </Text>
                    </View>
                  </View>
                  <View style={{display: 'flex', flexDirection: 'row', alignItems: 'flex-end'}}>
                    <Text style={styles.TopName}>Year/Make/Model </Text>
                    <View style={styles.Yearline}>
                      <Text style={[styles.formdata, handwritingStyle, {fontSize:'14',marginTop:'-6'}]}>
                        {`${certificateData && certificateData?.CertificateData?.Year
                        }/ ${certificateData && certificateData?.CertificateData?.Make
                        } /${certificateData && certificateData?.CertificateData?.Model
                        }`}
                      </Text>
                    </View>
                  </View>
                  <View style={{display: 'flex', flexDirection: 'row'}}>
                    <Text style={styles.TopName}>Has Current Registration Sticker</Text>
                    <View style={styles.checkbox}>
                      <Image style={{position:'absolute',height:'12px' }} source={tickimg}/>
                      {/*{certificateData&& certificateData?.CertificateData?.Registration_Stricker?.status==true? (*/}
                      {/*  <Image style={{position:'absolute',height:'12px' }} source={tickimg}/>*/}
                      {/*):null*/}
                      {/*}*/}
                    </View><Text style={styles.RegText}>Yes</Text>
                    <View style={styles.checkbox1}>
                      {/*{certificateData && certificateData?.CertificateData?.Registration_Stricker?.status==false? (*/}
                      {/*  <Image style={{position:'absolute',height:'12px' }} source={tickimg}/>*/}
                      {/*):null*/}
                      {/*}*/}
                    </View><Text style={styles.RegText1}>No</Text>
                  </View>
                  <View style={{display: 'flex', flexDirection: 'row', alignItems: 'flex-end'}}>
                    <Text style={styles.TopName}>Registration Sticker Month/Year</Text>
                    <View style={styles.Registrationline}>
                      <Text style={[styles.formdata, handwritingStyle]}>
                        {certificateData && certificateData?.CertificateData?.Registration_Stricker_Month_Year}
                      </Text>
                    </View>
                  </View>
                  <View style={{display: 'flex', flexDirection: 'row', alignItems: 'flex-end'}}>
                    <Text style={styles.TopName}>Inspection Co Name</Text>
                    <View style={styles.CoNameline}>
                      <Text style={[styles.formdata, handwritingStyle]}>
                        Chex Inc.
                      </Text>
                    </View>
                  </View>
                  <View style={{display: 'flex', flexDirection: 'row', alignItems: 'flex-end'}}>
                    <Text style={styles.TopName}>Inspection Co Address</Text>
                    <View style={styles.CoAddressline}>
                      <Text style={{marginTop:'-4',fontFamily:'Lato',fontSize:'9.7px',marginLeft:'5px',marginBottom:0}}>
                        {certificateData && certificateData?.CertificateData?.Inspection_Co_Address}
                      </Text>
                    </View>
                  </View>
                  <View style={{display: 'flex', flexDirection: 'row', alignItems: 'flex-end'}}>
                    <Text style={styles.TopName}>Mechanic's Certification Number</Text>
                    <View style={styles.Mechanicline}>
                      <Text style={[styles.formdata, handwritingStyle]}>
                        {certificateData && certificateData?.CertificateData?.Certification_Number}
                      </Text>
                    </View>
                  </View>
                  <View style={{display: 'flex', flexDirection: 'row', alignItems: 'flex-end'}}>
                    <Text style={styles.TopName}>Getaround Car Name</Text>
                    <View style={styles.Getaroundline}>
                      <Text style={{marginTop:'-7',fontFamily:'Lato',fontSize:'16px',marginLeft:'10px',marginBottom:-5}}>
                        {certificateData && certificateData?.CertificateData?.Getaround_Car_Name}
                      </Text>
                    </View>
                  </View>
                  <View style={{display: 'flex', flexDirection: 'row', alignItems: 'flex-end'}}>
                    <Text style={styles.TopName}>Inspection Date</Text>
                    <View style={styles.Dateline}>
                      <Text style={[styles.formdata, handwritingStyle]}>
                       {moment(certificateData && certificateData?.CertificateData?.Inspection_Date).format("MM-DD-YYYY")}
                      </Text>
                    </View>
                  </View>
                  <View style={{display: 'flex', flexDirection: 'row', alignItems: 'flex-end'}}>
                    <Text style={styles.TopName}>Inspector Name</Text>
                    <View style={styles.Dateline}>
                      <Text style={[styles.formdata, handwritingStyle]}>
                        {`${certificateData?.CertificateData?.Inspector_Name || ''} ${certificateData?.CertificateData?.Inspector_Last_Name || ''}`.trim()}
                      </Text>
                    </View>
                  </View>
                  <View style={{display: 'flex', flexDirection: 'row'}}>
                    <Text style={styles.TopName}>Inspector Signature</Text>
                    <View style={styles.Signatureline}>
                      {certificateData && certificateData?.CertificateData?.Inspector_Signature? (
                        <Image
                          style={{
                            width: 170,
                            height: 52,
                            objectFit: 'contain',
                            position: 'absolute',
                            top: 60,
                            left: 50,
                            zIndex: 10,
                          }}
                          source={`${process.env.REACT_APP_AWS_S3_LINK}/${
                            certificateData && certificateData?.CertificateData?.Inspector_Signature
                          }?x-request=xhr`}
                        />
                      ) : (
                        <Text style={{marginTop:'-10',fontFamily:'Lato',fontSize:'14px',marginLeft:'5px'}}>
                          {`${certificateData  && certificateData ?.CertificateData?.Inspector_Name
                        } ${certificateData && certificateData?.CertificateData?.Inspector_Last_Name

                        }`}</Text>
                      )}
                    </View>
                  </View>
                  <Text style={{...styles.submitpara,paddingRight:10}}> Use this diagram to indicate all visible damage on
                    the vehicle including dents, rust, etc.</Text>
                  <View>
                    <Image style={styles.backimg}
                           src={'https://res.cloudinary.com/dgjordf6e/image/upload/v1677503568/Screen_Shot_2023-02-22_at_9.15_1_pisdyv.png'}/>
                  </View>
                </View>
                <View style={styles.RightContent}>
                  <Image style={{height:'925',marginLeft:'4%',marginTop:'23px',width:'90%'}} source={InspectorPoint} alt="img"/>
                  {/*<View style={{display:'flex', flexDirection:'row',padding: 3}}>*/}
                  {/*  <View style={styles.InspectionTxt}>*/}
                  {/*    <Text>*/}
                  {/*      Inspection Point*/}
                  {/*    </Text>*/}

                  {/*  </View>*/}
                  {/*  <View style={styles.passTtext}>*/}
                  {/*    <Text>*/}
                  {/*      Pass*/}
                  {/*    </Text>*/}

                  {/*  </View>*/}
                  {/*  <View style={styles.passTtext}>*/}
                  {/*    <Text>*/}
                  {/*      Fail*/}
                  {/*    </Text>*/}

                  {/*  </View>*/}
                  {/*</View>*/}
                  {/*<View style={{display:'flex', flexDirection:'column', }}>*/}

                  {/*  {certificateData?.CertificateData?.Inspection_Point?.map((checks, index) =>*/}
                  {/*    (*/}
                  {/*      <View>*/}
                  {/*        {checks?.category_Name=='Tires'?(*/}
                  {/*            <View>*/}
                  {/*              <View style={{display:'flex', flexDirection:'row',padding: 3,marginTop:'-7px' }}>*/}
                  {/*                <View style={styles.Topborder}>*/}
                  {/*                  <Text style={{fontFamily:'Arialbold',fontWeight:700,marginLeft:'1%',fontSize:'14px',paddingTop:5,paddingBottom: 5}}>*/}
                  {/*                    {checks?.category_Name}*/}
                  {/*                  </Text>*/}
                  {/*                </View>*/}
                  {/*                <View style={styles.rightsideborder}>*/}
                  {/*                  <View style={styles.Rightcheckbox}>*/}
                  {/*                    {checks?.check[0]?.status==true?(*/}
                  {/*                      <Image style={{position:'absolute',height:'13px' }} src={tickimg}/>*/}
                  {/*                    ):null}*/}
                  {/*                  </View>*/}
                  {/*                </View>*/}
                  {/*                <View style={styles.rightsideborder}>*/}
                  {/*                  <View style={styles.Rightcheckbox}>*/}
                  {/*                    {checks?.check[0]?.status==false?(*/}
                  {/*                      <Image style={{position:'absolute',height:'13px' }} src={tickimg}/>*/}
                  {/*                    ):null}*/}
                  {/*                  </View>*/}
                  {/*                </View>*/}
                  {/*              </View>*/}
                  {/*              {checks?.check?.map((data,ind)=>*/}
                  {/*                <View>*/}
                  {/*                  <View style={{display:'flex', flexDirection:'row',padding: 3,marginTop:'-7px' }}>*/}
                  {/*                    <View style={styles.Topborder}>*/}
                  {/*                      <Text style={{fontFamily:'Inter',fontSize:'14px',width:'97%',marginLeft:'1%',paddingTop:5,paddingBottom: 5}}>*/}
                  {/*                        {data?.Check?.name}*/}
                  {/*                      </Text>*/}

                  {/*                    </View>*/}
                  {/*                    <View style={styles.rightsideborder}>*/}
                  {/*                    </View>*/}
                  {/*                    <View style={styles.rightsideborder}>*/}
                  {/*                    </View>*/}
                  {/*                  </View>*/}
                  {/*                </View>*/}

                  {/*              )}*/}
                  {/*            </View>*/}
                  {/*          ):*/}
                  {/*          <View>*/}
                  {/*            <View style={{display:'flex', flexDirection:'row',padding: 3,marginTop:'-7px',Top:24 }}>*/}
                  {/*              <View style={styles.Topborder}>*/}
                  {/*                <Text style={{fontFamily:'Arialbold',fontWeight:700,marginLeft:'1%',fontSize:'14px',paddingTop:5,paddingBottom: 5}}>*/}
                  {/*                  {checks?.category_Name}*/}
                  {/*                </Text>*/}
                  {/*              </View>*/}
                  {/*              <View style={styles.rightsideborder}>*/}
                  {/*              </View>*/}
                  {/*              <View style={styles.rightsideborder}>*/}
                  {/*              </View>*/}
                  {/*            </View>*/}
                  {/*            {checks?.check?.map((data,ind)=>*/}
                  {/*              <View>*/}
                  {/*                <View style={{display:'flex', flexDirection:'row',padding: 3,marginTop:'-7px' }}>*/}
                  {/*                  <View style={styles.Topborder}>*/}
                  {/*                    <Text style={{fontFamily:'Inter',fontSize:'14px',width:'95%',marginLeft:'1%',paddingTop:5,paddingBottom: 5}}>*/}
                  {/*                      {data?.Check?.name}*/}
                  {/*                    </Text>*/}

                  {/*                  </View>*/}
                  {/*                  <View style={styles.rightsideborder}>*/}
                  {/*                    <View style={styles.Rightcheckbox}>*/}
                  {/*                      {checks?.check[ind]?.status==true?(*/}
                  {/*                        <Image style={{position:'absolute',height:'13px' }} src={tickimg}/>*/}
                  {/*                      ):null}*/}
                  {/*                    </View>*/}
                  {/*                  </View>*/}
                  {/*                  <View style={styles.rightsideborder}>*/}
                  {/*                    <View style={styles.Rightcheckbox}>*/}
                  {/*                      {checks?.check[ind]?.status==false?(*/}
                  {/*                        <Image style={{position:'absolute',height:'13px' }} src={tickimg}/>*/}
                  {/*                      ):null}*/}
                  {/*                    </View>*/}
                  {/*                  </View>*/}
                  {/*                </View>*/}
                  {/*                {ind==checks?.check?.length-1?(*/}
                  {/*                  <View style={{display:'flex', flexDirection:'row',padding: 3,marginTop:'-7px' }}>*/}
                  {/*                    <View style={styles.Topborder}>*/}
                  {/*                      <View style={{padding:12}}></View>*/}
                  {/*                    </View>*/}
                  {/*                    <View style={styles.rightsideborder}>*/}

                  {/*                    </View>*/}
                  {/*                    <View style={styles.rightsideborder}>*/}
                  {/*                    </View>*/}
                  {/*                  </View>*/}
                  {/*                ):null}*/}
                  {/*              </View>*/}
                  {/*            )}*/}
                  {/*          </View>*/}
                  {/*        }*/}
                  {/*      </View>*/}

                  {/*    )*/}
                  {/*  )}*/}
                  {/*</View>*/}


                </View>
              </View>

            </Page>
          </Document>
        }
        fileName={fileName}
      >
        {({ blob, url, loading, error }) => (
          <>
            {loading ? (
              <div className="certificate-download-button is-loading" aria-live="polite">
                <span className="certificate-download-spinner" />
                <div>Preparing PDF</div>
              </div>
            ) : (
              <div
                className="certificate-download-button"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    fontSize: "15px",
                    marginBottom: "20px",
                    marginTop: "20px",
                    color: "#3FA9FF",
                    fontWeight: "bold",
                    marginRight: "5px",
                  }}
                >
                  {linkLabel}
                </div>
                <i className="fa fa-download" />
              </div>
            )}
          </>
        )}
      </PDFDownloadLink>
    </div>
  );
}


const GetAroundCertificateDownLoadConnected = (props) => {
  const { id, companyId, reportData, checksData } = props;
  React.useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      props.getVehicleCertificate({ id, companyId }, props.setLoading, "uber");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyId]);
  return (
    <div className="certificate-download-group">
      {!reportData ? (
        <div className="certificate-download-button is-loading" aria-live="polite">
          <span className="certificate-download-spinner" />
          <div>Loading certificate data</div>
        </div>
      ) : (
        getCertificateFontDownloads(reportData?.certificateFont).map((cfg) => (
          <GetAroundCertificateDownLoad
            key={cfg.handwritingFont}
            reportData={reportData} certificateData={reportData}
            checksData={checksData} checks={checksData} vehicleChecksArray={checksData} firstHalfData={checksData}
            handwritingFont={cfg.handwritingFont}
            fileName={cfg.fileName}
            linkLabel={cfg.linkLabel}
          />
        ))
      )}
    </div>
  );
};

function mapStateToProps(state) {
  const sliceData = state && state.vehicleInstruction && state.vehicleInstruction.getAroundCertificate;
  return {
    reportData: sliceData,
    checksData: [],
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(ActionCreators, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(GetAroundCertificateDownLoadConnected);
